// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"f2ddf579f0dd6efad692","215":"cc2a95d1ae79b2394413","417":"25455a28a4f5b4ffb596","506":"23655c1ffdd7e197e7ed","852":"6eaca6df87eb580ae4b3","874":"de363d7c635c8b1183c1"}[chunkId] + ".chunk.js";
};